export const useScrollTo = (ref) => {
  return () => ref && ref.current.scrollIntoView({ block: 'start', inline: 'start', behavior: 'smooth' });
}
